import type { StorefrontFamily } from "../types";

export type Channel = "amazon" | "flipkart";
const urlKey = { amazon: "amazonUrl", flipkart: "flipkartUrl" } as const;

// A card stands for the whole family, so each marketplace links to its lowest-priced listed option
// (the first one on a tie). The product page uses the chosen option, or this pick before one is chosen.
export function familyMarketplace(family: StorefrontFamily): Partial<Record<Channel, string>> {
  const links: Partial<Record<Channel, string>> = {};
  for (const channel of Object.keys(urlKey) as Channel[]) {
    const listed = family.variants.filter((variant) => variant.marketplace[urlKey[channel]]);
    if (!listed.length) continue;
    const cheapest = listed.reduce((best, variant) => (variant.price < best.price ? variant : best));
    links[channel] = cheapest.marketplace[urlKey[channel]];
  }
  return links;
}
